export default "__VITE_ASSET__TQv15xCk__"